import { render, staticRenderFns } from "./ListagemActive.vue?vue&type=template&id=ada016f4&scoped=true&"
import script from "./ListagemActive.vue?vue&type=script&lang=js&"
export * from "./ListagemActive.vue?vue&type=script&lang=js&"
import style0 from "./ListagemActive.vue?vue&type=style&index=0&id=ada016f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada016f4",
  null
  
)

export default component.exports